import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Grid, Typography, Button, Box } from "@mui/material";
import Homenavbar from "./Homenavbar";
import HeroSection from "./Homeherosection";
import Homekeyeatures from "./Homekeyfeatures";
import Homebusinesstransformation from "./Homebusinesstransformation";
import Homejoblist from "./Homejoblist";
import Homefooter from "./Homefooter";

import Howitworks from "./Howitworks";
import Benefits from "./Benefits";
import ImpactStats from "./ImpactStats";
import Pricing from "./Pricing";
import Testimonials from "./Testimonials";
import CTASection from "./CTASection";
import DemoRequestDialog from "./Components/DemoRequestDialog";

const JobsLandingPage = () => {
  const [demoDialogOpen, setDemoDialogOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('Home');

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out-cubic",
    });

    // Reset Meta Tags for Home Page
    document.title = "Bench Sales Jobs & Consultant Profiles | JobsnProfiles USA";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Find active bench consultants, bench sales jobs, and U.S. IT staffing opportunities on JobsnProfiles. Connect recruiters, employers, and consultants on one trusted platform.");
    }
  }, []);

  const handleDemoOpen = () => setDemoDialogOpen(true);
  const handleDemoClose = () => setDemoDialogOpen(false);

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Grid container spacing={4} >
        <Grid item xs={12}>

          <HeroSection
            onRequestDemo={handleDemoOpen}
            activeLink={activeLink}
            setActiveLink={setActiveLink}
          />
          <Howitworks />
          <Benefits activeLink={activeLink} />
          <ImpactStats />
          {/* <Pricing /> */}
          <Testimonials />
          <CTASection onRequestDemo={handleDemoOpen} />


          <Homefooter onRequestDemo={handleDemoOpen} />
        </Grid>
      </Grid>

      <DemoRequestDialog open={demoDialogOpen} onClose={handleDemoClose} />
    </Box>
  );
};


export default JobsLandingPage;

